import { DatePicker } from "@mui/x-date-pickers";
import { IconButton, Box } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const CustomDatePicker = ({ 
    disabled = false,
    label, 
    name, 
    value, 
    onChange, 
    touched, 
    errors, 
    format = "dd/MM/yyyy",
    minDate,
    maxDate,
    sx 
}) => {
    const handleClear = () => {
        onChange(name, null);
    };

    return (
        <Box sx={{ position: 'relative', ...sx }}>
            <DatePicker
                disabled={disabled}
                label={label}
                name={name}
                value={value}
                format={format}
                minDate={minDate}
                maxDate={maxDate}
                onChange={(newValue) => onChange(name, newValue)}
                slotProps={{
                    textField: {
                        variant: "filled",
                        fullWidth: true,
                        error: !!touched?.[name] && !!errors?.[name],
                        helperText: touched?.[name] && errors?.[name],
                    },
                }}
            />
            {!disabled && value && (
                <IconButton 
                    onClick={handleClear}
                    aria-label="clear date"
                    sx={{ 
                        position: 'absolute',
                        right: 35, 
                        top: '50%',
                        transform: 'translateY(-50%)',
                        '&:hover': {
                            backgroundColor: 'action.hover'
                        }
                    }}
                >
                    <ClearIcon />
                </IconButton>
            )}
        </Box>
    );
};

export default CustomDatePicker;